import sendAiGenItemLoadAnalytics from '@/utils/analytics/sendAiGenItemLoadAnalytics';

import type { AnalyticsSettings } from './analyticsSettings';

/** Send analytics for generation failure */
const sendGenerateFailureAnalytics = (
  processingTime: number,
  settings: AnalyticsSettings,
  errorMessage: string
) => {
  sendAiGenItemLoadAnalytics({
    result: 'failure',
    processing_time: processingTime,
    settings: {
      ...settings,
      error_type: 'generation_failed',
      error_message: errorMessage,
    },
  });
};

export default sendGenerateFailureAnalytics;
